<template>
<div>
     <v-dialog width="300" v-model="publicPageDialog" persistent>
    <v-card height="auto" v-if="!isPublic" :loading="loading">
      <v-card-title>Public Page Settings</v-card-title>
      <v-card-text>
         <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
        <v-text-field label="Page Title" outlined v-model="pageTitle" :rules="[rules.required, rules.counter]"></v-text-field>
        <v-text-field label="Page SubTitle" outlined v-model="pageSubTitle" :rules="[rules.required, rules.counter]"></v-text-field>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text @click="$emit('close')" >cancel</v-btn>
        <v-btn text color="primary" @click="makePublicPage" :loading="loading">make public</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title>Access Public Page &nbsp;<v-icon @click="share">mdi-share-variant</v-icon></v-card-title>
      <v-card-text>
        <a :href="url" target="_blank">{{url}}</a>
      </v-card-text>
      <v-card-actions>
        <v-btn outlined color="primary" @click="disablePage" :loading="loading">make private</v-btn>
        <v-btn text @click="$emit('close')" >cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
    
</template>
<script>
import { db } from "../../firebaseconfig";
import {Share} from '../plugins/capacitorPlugin.js'
import { mapGetters } from "vuex";
export default {
    props:['user','publicPage'],
    data(){
        return{
          valid:true,
          loading:false,
          isPublic:false,
             pageTitle:'',
             pageSubTitle:'',
      publicPageDialog:true,
      subDomain:'',
       rules: {
          required: value => !!value || 'Required.',
          counter: value => value.length > 5 || 'Min 5 characters',
        },
        }
    },
    async mounted(){
      this.isPublic=this.publicPage
      await db
        .ref('users')
        .child(this.user.uid)
        .child('isPublic')
        .once('value')
        .then(data=>{
          if(data.exists()){
            const val=data.val();
            this.isPublic=val.value;
            this.subDomain=val.subDomain
          }
        })

    },
    methods:{
     async disablePage(){
       this.loading=true
       await db.ref('public').child(this.subDomain).child('isPublic').set(false)
       await db
        .ref('users')
        .child(this.user.uid)
        .child('isPublic')
        .set({value:false,subDomain:this.subDomain}).then(()=>{
          this.loading=false
          this.isPublic=false
          this.$emit('close')
        }).catch(()=>{
          this.loading=false
          console.log('failed');
          this.$emit('close')
        })

     },
       validate () {
        this.$refs.form.validate();
      },
      async makePublicPage(){
        this.validate();
        if(this.valid){
                this.loading=true
      await db
        .ref('users')
        .child(this.user.uid)
        .child('isPublic')
        .child('subDomain')
        .once('value')
        .then(data=>{
          if(data.exists()){
            this.subDomain=data.val();
          }else{
            this.subDomain=db.ref('public').push().key
          }
        })

    await db
        .ref('users')
        .child(this.user.uid)
        .child('isPublic')
        .set({value:true,subDomain:this.subDomain})
   await  db.ref('public').child(this.subDomain).update({
      uid:this.user.uid,
      title:this.pageTitle,
      subTitle:this.pageSubTitle,
      isPublic:true
    }).then(()=>{
      this.loading=false
      this.isPublic=true;
    }).catch(()=>{
      this.loading=false
      console.log('failed');
    })  
     }
    },
    async share(){
    await Share.share({
            title: 'Share Public Page',
            text: '',
            url: this.url,
            dialogTitle: 'Share with buddies',})
}
},
computed:{
  ...mapGetters({
    url:'getPublicPageUrl'
  })
}
}
</script>